(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerDetailController', CompanyCustomerDetailController);

    CompanyCustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanyCustomer', 'Company', 'Customer'];

    function CompanyCustomerDetailController($scope, $rootScope, $stateParams, entity, CompanyCustomer, Company, Customer) {
        var vm = this;

        vm.companyCustomer = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companyCustomerUpdate', function (event, result) {
            vm.companyCustomer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
